import {ORelativePosition} from "back/commons/widgets/popupable";
import {POPUP} from "back/commons/widgets/popups";
import {IElementWedlet, IParentWedlet, IWedlet, WEDLET} from "back/edit/wed/wedlets/wedlet";
import {IWedletSingleElt} from "back/edit/wed/wedlets/wedletSingleElt";
import {Action} from "lib/commons/actions";
import {REG} from "lib/commons/registry";
import {DOM, JSX} from "lib/commons/xml/dom";
import {DOMSH} from "lib/commons/xml/domsh";
import {ISkImporter, OSkPasteContext} from "lib/edit/schema/schemaMeta";
import {XA} from "lib/commons/xml/xAddr";
import {ITxtElement, TxtRoot} from "back/edit/wed/wedlets/txt/txt";
import {GFX} from "lib/commons/utils/gfx";
import {IEltInsertDrawer, IWedEditorInsMgr, MarkImportInsert, MarkImportReplace, MarkImportReplaceCtn} from "back/edit/wed/features/insMgr";
import {findTxtStrParent} from "back/edit/wed/wedlets/txt/txtUtils";

interface ITxtRootInsMgr extends TxtRoot {
	/** Mémoire sur le txtRoot de l'import au point de Caret ou sur le Range de la Selection. */
	_insSelMarked?: MarkImportCaret | MarkImportSel;
}

interface IEltInsertDrawer_Txt extends IEltInsertDrawer, ITxtElement, HTMLElement {
	//_insCaretImporters: ISkImporter | ISkImporter[]
}

export function AgEltBoxInsertDrawerTxt(cls: any): any {
	const proto = cls.prototype as IEltInsertDrawer;
	proto.drawInsertMarks = drawInsertMarks_Txt;
	proto.removeInsertMarks = removeInsertMarks_Txt;
	return cls;
}


function drawInsertMarks_Txt(this: IEltInsertDrawer_Txt, importers: ISkImporter[], emptyStruct: boolean) {
	// if (this.wedlet.model.nodeName=== 'dk:text') {
	// 	console.log("drawInsertMarks", this, importers);
	// }
	this._insMarks = [];
	let isSelInThis: boolean;
	let replaceCh: Map<number | string, MarkImportReplaceCtn>;//mémoire des remplacements de fils.
	let insertCh: Map<number | string, MarkImportInsert>;//mémoire des insertions entre les fils.
	for (const imp of importers) {
		if (!imp.importPos) {
			console.log("drawInsertMarks_Txt::: !imp.importPos::", imp);
			return;
		}
		if (imp.importPos.replaceChildren) {
			//on remplace certains fils
			if (!replaceCh) replaceCh = new Map();
			for (const chPath of imp.importPos.replaceChildren) {
				let mark = replaceCh ? replaceCh.get(chPath) : null;
				if (mark) {
					if (WEDLET.matchModel(imp.importPos.similarTo, mark.from.model)) mark.addImporter(imp);
				} else {
					const ch = (this.wedlet as IParentWedlet).findWedletChild(chPath, WEDLET.VISITOPTIONS_mainBranch) as any as IWedletSingleElt & ITxtElement;
					if (ch && WEDLET.matchModel(imp.importPos.similarTo, ch.wedlet.model)) {
						mark = new MarkImportReplace().placeOn(ch, imp, ch.element);
						this._insMarks.push(mark);
						replaceCh.set(chPath, mark);
					}
				}
			}
		}
		if (imp.importPos.insertOffsetMin !== undefined) {
			//on injecte des marques d'insertion
			if (this.isTextContainer) {
				//On est dans un noeud texte d'un TxtRoot qui admet au moins un import
				//Si le caret ou le début de la sel est dans ce noeud texte, on active
				const txtRoot = this.txtRoot as ITxtRootInsMgr;
				if (txtRoot._insSelMarked === undefined) {
					const selMgr = txtRoot.selMgr;
					const typeSel = selMgr.type;
					if (typeSel === "Range" || typeSel === "Caret") {
						if (DOM.isAncestor(this, selMgr.range.startContainer)) {
							isSelInThis = true;
							if (typeSel === "Range") {
								txtRoot._insSelMarked = new MarkImportSel(this.wedlet, txtRoot, imp);
							} else {
								txtRoot._insSelMarked = new MarkImportCaret().init(this.wedlet, imp, this, selMgr.range);
							}
						}
					}
				} else if (isSelInThis) {
					txtRoot._insSelMarked.addImporter(imp);
				}
				//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
				//console.log("Mark on text....", imp, this);
				// if (!this._insCaretImporters) {
				// 	this._insCaretImporters = imp;
				// 	this.addEventListener('dragenter', onParaDragEnter);
				// 	this.addEventListener('dragover', onParaDragOver);
				// 	this.addEventListener('dragleave', onParaDragLeave);
				// 	this.addEventListener('drop', onParaDrop);
				// } else if (Array.isArray(this._insCaretImporters)) {
				// 	this._insCaretImporters.push(imp);
				// } else {
				// 	this._insCaretImporters = [this._insCaretImporters, imp];
				// }
			} else {
				if (!insertCh) insertCh = new Map();
				let previousCh: IWedlet;
				for (let i = imp.importPos.insertOffsetMin; i <= imp.importPos.insertOffsetMax; i++) {
					let mark = insertCh.get(i);
					if (mark) {
						mark.addImporter(imp);
					} else {
						const ch = (this.wedlet as IParentWedlet).findWedletChild(i, WEDLET.VISITOPTIONS_mainBranch) as IWedlet;
						mark = new MarkImportInsert().setClass('small').placeOn(this.wedlet, imp, this, i, ch, previousCh);
						this._insMarks.push(mark);
						insertCh.set(i, mark);
						previousCh = ch;
					}
				}
			}
		}
	}
}

//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
// function onParaDragEnter(this: IEltInsertDrawer_Txt, ev: DragEvent) {
// 	ev.preventDefault();
// 	ev.stopImmediatePropagation();
// 	const typeSel = this.txtRoot.selMgr.type;
// 	if (typeSel === "Caret") {
// 		//On marque l'emplacement du caret
// 		ev.dataTransfer.dropEffect = "link";
// 		let editor = this.wedlet.wedMgr.wedEditor as IWedEditorInsMgr;
// 		if (!editor._insCaret) editor._insCaret = new MarkImportCaret().init(editor.wedMgr);
// 		this.txtRoot.appendChild(editor._insCaret);
// 	}
// 	//console.log("selMgrAsIs;;;;", this, this.txtRoot.selMgrAsIs._sel, this.txtRoot.selMgrAsIs.range.getBoundingClientRect());
// }
// function onParaDragOver(this: IEltInsertDrawer_Txt, ev: DragEvent) {
// 	ev.preventDefault();
// 	ev.stopImmediatePropagation();
// 	//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
// 	//let caretPos = DOMSH.findDocumentOrShadowRoot(this).caretPositionFromPoint(ev.x, ev.y);
// 	//console.log("onParaDragOver:::TODO move editor._insCaret", ev.x, ev.y);
// }
// function onParaDragLeave(this: IEltInsertDrawer_Txt, ev: DragEvent) {
// 	ev.preventDefault();
// 	let editor = this.wedlet.wedMgr.wedEditor as IWedEditorInsMgr;
// 	if (editor._insCaret && editor._insCaret.parentNode) editor._insCaret.remove();
// 	DOM.setAttr(this.txtRoot, "dragOn", null);
// }
// function onParaDrop(this: IEltInsertDrawer_Txt, ev: DragEvent) {
// 	//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
// }

function removeInsertMarks_Txt(this: IEltInsertDrawer_Txt) {
	if (this._insMarks) {
		for (const mark of this._insMarks) mark.remove();
		this._insMarks = null;
	}
	const txtRoot = this.txtRoot as ITxtRootInsMgr;
	if (txtRoot._insSelMarked) {
		txtRoot._insSelMarked.remove();
		txtRoot._insSelMarked = undefined;
	}
	//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
	// if (this._insCaretImporters) {
	// 	this._insCaretImporters = null;
	// 	this.removeEventListener('dragenter', onParaDragEnter);
	// 	this.removeEventListener('dragover', onParaDragOver);
	// 	this.removeEventListener('dragleave', onParaDragLeave);
	// 	this.removeEventListener('drop', onParaDrop);
	// 	DOM.setAttr(this.txtRoot, "dragOn", null);
	// }
}

/**
 * Marque d'insertion sur la position du caret dans un texte
 */
class MarkImportCaret extends MarkImportInsert {
	placeOn(from: IWedlet, importer: ISkImporter, parentRef: IElementWedlet): this {
		throw Error();
	}

	init(from: IWedlet, importer: ISkImporter, para: IEltInsertDrawer_Txt, rgCaret: Range): this {
		this.from = from;
		this.importer = importer;
		from.wedMgr.reg.installSkin(this.localName, this.attachShadow(DOMSH.SHADOWDOM_INIT));
		if (rgCaret.startContainer instanceof Text) {
			rgCaret.startContainer.parentNode.insertBefore(this, rgCaret.startContainer.splitText(rgCaret.startOffset));
		} else {
			console.error("MarkImportCaret caret position::::", rgCaret);
		}
		return this;
	}

	protected buildImportContext(): OSkPasteContext {
		const txtStr = findTxtStrParent(this);
		if (txtStr.isVirtual()) {
			return {sel: {start: XA.append(txtStr.wedAnchor, 0)}, virtualPath: WEDLET.buildVirtualPath(txtStr)}
		} else {
			const offset = txtStr.getXmlOffset(this, 0) + 1; //FIXME TxtStr endEdgeOffset (+1)
			return {sel: {start: XA.append(txtStr.wedAnchor, offset)}};
		}
	}

	remove() {
		const parent = this.parentElement;
		super.remove();
		parent.normalize();
	}
}

REG.reg.registerSkin('txt-mark-caret', 1, /* language=CSS */ `
	:host {
		display: inline-block;
		position: absolute;
		z-index: 910;
		width: 16px;
		margin-inline-start: -8px;
		margin-block-start: -.3em;
		height: 2em;
		box-sizing: border-box;
		background-color: var(--edit-drop-color);
		background-clip: padding-box;
		border: 6px solid transparent;
		border-bottom-width: .3em;
		border-top-width: .3em;
		border-radius: 12px;
	}

	:host(.over),
	:host(:hover) {
		width: 20px;
		margin-inline-start: -10px;
		border: 7px solid var(--edit-drop-bgcolor);
	  border-bottom-width: .1em;
	  border-top-width: .1em;
	}
`);
customElements.define('txt-mark-caret', MarkImportCaret);

/**
 * Insertion correspondant à la sélection du texte.
 * NOTE : La classe s'appelle MarkImportSel par analogie aux autres points d'insertions MarkImportXxx,
 * mais ce n'est pas un widget Html : c'est le style de la Selection Html qui est modifiée.
 */
class MarkImportSel {
	importer: ISkImporter | ISkImporter[];

	constructor(public from: IWedlet, public txtRoot: ITxtRootInsMgr, imp: ISkImporter) {
		this.importer = imp;
		txtRoot.addEventListener('dragover', this.onTxtDragOverSel);
		txtRoot.addEventListener('drop', this.onTxtDropOverSel);
	}

	addImporter(importer: ISkImporter) {
		if (!Array.isArray(this.importer)) this.importer = [this.importer, importer];
		else this.importer.push(importer);
	}

	remove() {
		DOM.setAttr(this.txtRoot, "dragOn", null);
		this.txtRoot.removeEventListener('dragover', this.onTxtDragOverSel);
		this.txtRoot.removeEventListener('drop', this.onTxtDropOverSel);
	}

	isOnSel(x: number, y: number): boolean {
		const rects = this.txtRoot.selMgrAsIs.range.getClientRects();
		for (let i = 0; i < rects.length; i++) if (GFX.isPointIn(rects.item(i), x, y)) return true;
		return false;
	}

	onTxtDragOverSel(this: ITxtRootInsMgr, ev: DragEvent) {
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if ((this._insSelMarked as MarkImportSel).isOnSel(ev.x, ev.y)) {
			ev.dataTransfer.dropEffect = "link";
			DOM.setAttr(this.txtRoot, "dragOn", "sel");
		} else {
			ev.dataTransfer.dropEffect = "none";
			DOM.setAttr(this.txtRoot, "dragOn", null);
		}
	}

	onTxtDropOverSel(this: ITxtRootInsMgr, ev: DragEvent) {
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if ((this._insSelMarked as MarkImportSel).isOnSel(ev.x, ev.y)) {
			(this._insSelMarked as MarkImportSel).execute(ev.dataTransfer);
		}
	}

	async execute(dataTransfer?: DataTransfer) {
		const editor = this.from.wedMgr.wedEditor as IWedEditorInsMgr;
		if (Array.isArray(this.importer)) {
			const actions = [];
			for (const imp of this.importer) {
				if (dataTransfer && imp.completeDatasAtDrop) {
					if (await imp.completeDatasAtDrop(dataTransfer) === 'stop') continue;
				}
				actions.push(new Action().setLabel(imp.getLabel()).setExecute(() => {this.executeImporter(imp)}));
			}
			switch (actions.length) {
			case 0: {
				POPUP.showNotifInfo("Import incompatible", this.txtRoot);
				return;
			}
			case 1: {
				return actions[0].execute(null);
			}
			default:
				const action = await POPUP.showPopupActions({actions}, {posFrom: this.txtRoot, fromY: 'middle', targetY: 'middle'} as ORelativePosition, editor);
				if (!action) editor.endInsertSession();
			}
		} else {
			if (dataTransfer && this.importer.completeDatasAtDrop) {
				if (await this.importer.completeDatasAtDrop(dataTransfer) === 'stop') {
					POPUP.showNotifInfo("Import incompatible", this.txtRoot);
					return;
				}
			}
			return this.executeImporter(this.importer);
		}
	}

	async executeImporter(imp: ISkImporter) {
		//console.log("executeImporter:::", imp);
		try {
			if (imp.needAsyncBuild) {
				if (await imp.buildContentToImport(this.from.wedMgr.wedEditor) === 'stop') return;
				//Un dialogue d'import a pu provoquer une perte du focus et de la sel, on la restaure.
				this.txtRoot.selMgrAsIs.restoreSel();
			}
			const ctx = this.buildImportContext();
			if (ctx) {
				const batch = this.from.wedMgr.docHolder.newBatch();
				imp.doImport(ctx, batch);
				batch.doBatch();
			}
		} finally {
			(this.from.wedMgr.wedEditor as IWedEditorInsMgr).endInsertSession();
		}
	}

	protected buildImportContext(): OSkPasteContext {
		if (this.txtRoot.selMgr.type === "Range") {
			return {sel: this.txtRoot.selMgr.getXaRange()};
		} else {
			return null;
		}
	}


}

//WAIT impl Chrome https://bugs.chromium.org/p/chromium/issues/detail?id=388976
// class MarkImportCaret extends HTMLElement {
// 	init(wedMgr: WedMgr): this {
// 		wedMgr.reg.installSkin(this.localName, this.attachShadow(DOMSH.SHADOWDOM_INIT));
// 		return this;
// 	}
// }
// REG.reg.registerSkin('box-mark-caret', 1, /* language=CSS */ `
// 	:host {
// 		display: block;
// 		position: absolute;
// 		width: 2px;
// 		background-color: #0000cc;
// 		z-index: 10000;
// 	}
// `);
// customElements.define('box-mark-caret', MarkImportCaret);
